import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./Track.module.css";
import NavBar from "../../Components/interface/NavBar";
import BottomNav from "../../Components/BottomNav";
// import GoogleMapReact from "google-map-react";
import { Map, Marker } from "pigeon-maps";
import { useSelector } from "react-redux";
import CustomerScans from "../../utils/api/CustomerScans";
import mapImg from "../../asset/images/map.png";
import mapImg2 from "../../asset/images/map2.png";
import mapImg3 from "../../asset/images/map3.png";
import Modal from "../../Components/UI/Modal";

import { useNavigate } from "react-router";

const AnyReactComponent = ({ direction, image }) => {
  const markerRef = useRef(null);
  let parent = markerRef.current?.parentNode;
  if (parent) {
    parent.className = "map-transition";
  }
  return (
    <div
      style={{
        width: "40px",
        height: "40px",
        textAlign: "center",
        background: "transparent",
      }}
      ref={markerRef}
    >
      <img
        src={image}
        style={{ height: "40px", transform: `rotate(${direction}deg)` }}
        alt="car"
      />
    </div>
  );
};

function Track(props) {
  const defaultCenter = [6.509544, 3.371094];

  const [liveMetrics, setLiveMetrics] = useState(null);
  const [address, setAddress] = useState(null);
  const [timer, setTimer] = useState(30);
  const [mapIcon, setMapIcon] = useState(mapImg);
  const [mapZoom, setMapZoom] = useState(17);
  const [errorModal, setErrorModal] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [center, setCenter] = useState(defaultCenter);

  const personalData = useSelector((data) => data.auth);

  const dongle = useSelector((data) => data.dongles);

  const navigate = useNavigate();

  const fetchBasicMetrics = useCallback(async () => {
    try {
      const res = await CustomerScans.scanVehiclesHandler({
        user: personalData?.generalLoginData?.id,
        device: dongle?.dongleData?.dongle,
        access_token: personalData?.token,
      });
      setLiveMetrics(res.data.data);
      setCenter([
        res.data.data?.scan_data?.vehicle_location?.latitude,
        res.data.data?.scan_data?.vehicle_location?.longitude,
      ]);
    } catch (err) {
      setLiveMetrics("Error");
      setErrorModal(true);
    }
  }, [
    personalData.generalLoginData,
    personalData.token,
    dongle?.dongleData,
    // navigate,
  ]);

  useEffect(() => {
    if (liveMetrics?.scan_data?.vehicle_live_data?.online !== true) {
      setMapIcon(mapImg);
    } else if (
      liveMetrics?.scan_data?.vehicle_live_data?.online === true &&
      liveMetrics?.scan_data?.vehicle_live_data?.speed === 0
    ) {
      setMapIcon(mapImg2);
    } else {
      setMapIcon(mapImg3);
    }
  }, [
    liveMetrics?.scan_data?.vehicle_live_data?.online,
    liveMetrics?.scan_data?.vehicle_live_data?.speed,
  ]);

  // map center state

  useEffect(() => {
    if (dongle?.dongleData?.dongle?.length !== 0) {
      //fetch basic metrics
      fetchBasicMetrics();
    }
    // if (dongle?.dongleData?.dongle === null) {
    //   // naviagte home if no dongle device is found
    //   navigate("/home");
    // }
  }, [fetchBasicMetrics, dongle?.dongleData]);

  useEffect(() => {
    let timeout;
    if (liveMetrics?.scan_data?.vehicle_live_data?.online === true) {
      timeout = setTimeout(() => {
        if (timer > 0) {
          setTimer((timer) => timer - 1);
        } else {
          setTimer(30);
        }
      }, 1000);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [timer, liveMetrics?.scan_data?.vehicle_live_data?.online]);

  useEffect(() => {
    let intervalId;
    if (liveMetrics?.scan_data?.vehicle_live_data?.online === true) {
      fetchBasicMetrics(); // Initial fetch
      intervalId = setInterval(() => {
        fetchBasicMetrics(); // Fetch data every 30 seconds
      }, 30000); // 30 seconds in milliseconds
    }

    return () => {
      clearInterval(intervalId); // Clear interval when component unmounts
    };
  }, [liveMetrics?.scan_data?.vehicle_live_data?.online, fetchBasicMetrics]);

  useEffect(() => {
    const fetchAddress = async () => {
      try {
        const address = await CustomerScans.getUserAddress({
          lat: liveMetrics?.scan_data?.vehicle_location?.latitude,
          lng: liveMetrics?.scan_data?.vehicle_location?.longitude,
        });
        setAddress(address?.data?.results[3]?.formatted_address);
      } catch (err) {
        console.log(err);
      }
    };
    fetchAddress();
  }, [
    liveMetrics?.scan_data?.vehicle_location?.latitude,
    liveMetrics?.scan_data?.vehicle_location?.longitude,
  ]);

  // const defaultProps = {
  //   center: {
  //     lat: liveMetrics?.scan_data?.vehicle_location?.latitude,
  //     lng: liveMetrics?.scan_data?.vehicle_location?.longitude,
  //   },
  //   zoom: 17,
  // };

  const handleBoundsChange = (center, zoom) => {
    // Update the map center and zoom when the bounds change
    // setMapCenter({
    //   lat: center[0],
    //   lng: center[1],
    // });
    setCenter(center);
    setMapZoom(zoom);
  };
  // Trigger loading var function.
  const backHandler = () => {
    setErrorModal(false);
    setRedirect(true);
    setTimeout(() => {
      navigate(`/spare-parts/tracker`);
      setRedirect(false);
    }, 3000);
  };
  return (
    <section className={styles.body}>
      {redirect && (
        <Modal
          message="Loading Dongles page."
          back=""
          accept=""
          loader="true"
        />
      )}
      {errorModal && (
        <Modal
          title=""
          message={`Sorry!

          It appears that you don’t have a tracker linked to your account.
          
          Buy Tracker`}
          accept="See Trackers"
          back=""
          close={backHandler}
          confirm={backHandler}
        />
      )}
      <NavBar
        onlineStatus={liveMetrics?.scan_data?.vehicle_live_data?.online}
        title="Track"
        setShowMenu={props.setShowMenu}
      />{" "}
      <div className={styles.head}>
        {/* <UserNav
          onlineStatus={liveMetrics?.scan_data?.vehicle_live_data?.online}
        /> */}
        <div className={styles.main_hero}>
          {liveMetrics && (
            <div style={{ height: "85vh", width: "100%" }}>
              <Map
                center={center}
                zoom={17}
                onBoundsChanged={handleBoundsChange}
              >
                <Marker
                  anchor={[
                    liveMetrics?.scan_data?.vehicle_location?.latitude,
                    liveMetrics?.scan_data?.vehicle_location?.longitude,
                  ]}
                  payload={1}
                >
                  <AnyReactComponent
                    image={mapIcon}
                    lat={liveMetrics?.scan_data?.vehicle_location?.latitude}
                    lng={liveMetrics?.scan_data?.vehicle_location?.longitude}
                    direction={
                      liveMetrics?.scan_data?.vehicle_location?.direction
                    }
                  />
                </Marker>
              </Map>

              {/* <GoogleMapReact
                  bootstrapURLKeys={{
                    key: process.env.REACT_APP_KEY,
                    libraries: [
                      "geometry",
                      "drawing",
                      "places",
                      "journeySharing",
                      "localContext",
                    ],
                  }}
                  layerTypes={["TrafficLayer", "TransitLayer"]}
                  defaultCenter={defaultProps?.center}
                  defaultZoom={defaultProps?.zoom}
                  center={mapCenter}
                  zoom={mapZoom}
                  onChange={handleBoundsChange}
                  yesIWantToUseGoogleMapApiInternals
                >
                  <AnyReactComponent
                    image={mapIcon}
                    lat={liveMetrics?.scan_data?.vehicle_location?.latitude}
                    lng={liveMetrics?.scan_data?.vehicle_location?.longitude}
                    direction={
                      liveMetrics?.scan_data?.vehicle_location?.direction
                    }
                  />
                </GoogleMapReact> */}
            </div>
          )}
          {!liveMetrics && (
            <Modal message="Map Loading..." back="" accept="" loader="true" />
          )}

          {liveMetrics && (
            <div className={styles.metrics}>
              <div className={styles.metrics_inner}>
                <div className={styles.metrics_inner_wrapper}>
                  <div
                    className={styles.relocate}
                    onClick={() => {
                      setMapZoom(mapZoom);
                      // setMapCenter({
                      //   lat: 3.371094,
                      //   lng: 6.509544,
                      // });
                      setCenter([
                        liveMetrics?.scan_data?.vehicle_location?.latitude,
                        liveMetrics?.scan_data?.vehicle_location?.longitude,
                      ]);
                    }}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1_1926)">
                        <path
                          d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM16.5 7.5L14 14L7.5 16.5L10 10L16.5 7.5ZM12 13C12.2652 13 12.5196 12.8946 12.7071 12.7071C12.8946 12.5196 13 12.2652 13 12C13 11.7348 12.8946 11.4804 12.7071 11.2929C12.5196 11.1054 12.2652 11 12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12C11 12.2652 11.1054 12.5196 11.2929 12.7071C11.4804 12.8946 11.7348 13 12 13Z"
                          fill="#3E414C"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1_1926">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>

                  <div className={styles.metrics_list}>
                    <div>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.36192 3.65403C5.24953 2.90861 6.34521 2.4547 7.49992 2.35403V3.4987C7.49992 3.63131 7.5526 3.75848 7.64637 3.85225C7.74013 3.94602 7.86731 3.9987 7.99992 3.9987C8.13253 3.9987 8.2597 3.94602 8.35347 3.85225C8.44724 3.75848 8.49992 3.63131 8.49992 3.4987V2.35403C9.85338 2.47425 11.1186 3.07668 12.0651 4.05157C13.0116 5.02647 13.5764 6.30895 13.6566 7.66536H12.4999C12.3673 7.66536 12.2401 7.71804 12.1464 7.81181C12.0526 7.90558 11.9999 8.03276 11.9999 8.16536C11.9999 8.29797 12.0526 8.42515 12.1464 8.51892C12.2401 8.61269 12.3673 8.66536 12.4999 8.66536H13.6293C13.4559 10.2067 12.6806 11.4974 11.5173 12.444C11.4143 12.5278 11.349 12.6491 11.3354 12.7811C11.3219 12.9131 11.3614 13.0451 11.4453 13.148C11.5291 13.2509 11.6503 13.3163 11.7823 13.3298C11.9144 13.3433 12.0463 13.3038 12.1493 13.22C13.6333 12.0114 14.5959 10.2907 14.6626 8.23003C14.667 8.19555 14.6679 8.1607 14.6653 8.12603L14.6666 7.9987C14.6666 4.3167 11.6819 1.33203 7.99992 1.33203C4.31792 1.33203 1.33325 4.3167 1.33325 7.9987C1.33325 10.1667 2.34859 11.968 3.84659 13.216C3.94884 13.2972 4.07876 13.3351 4.20861 13.3217C4.33845 13.3083 4.45791 13.2447 4.54148 13.1444C4.62504 13.0442 4.66608 12.9152 4.65582 12.7851C4.64556 12.6549 4.58483 12.534 4.48659 12.448C3.34659 11.4974 2.55125 10.2034 2.37192 8.66536H3.49992C3.63253 8.66536 3.7597 8.61269 3.85347 8.51892C3.94724 8.42515 3.99992 8.29797 3.99992 8.16536C3.99992 8.03276 3.94724 7.90558 3.85347 7.81181C3.7597 7.71804 3.63253 7.66536 3.49992 7.66536H2.34259C2.41592 6.4107 2.89659 5.26536 3.65525 4.3607L4.47992 5.18536C4.5747 5.27368 4.70007 5.32177 4.8296 5.31948C4.95913 5.3172 5.08272 5.26472 5.17433 5.17311C5.26594 5.0815 5.31842 4.95791 5.3207 4.82838C5.32299 4.69885 5.27491 4.57348 5.18659 4.4787L4.36192 3.65403ZM11.1733 4.42136C11.0958 4.3617 11.0003 4.33018 10.9025 4.332C10.8047 4.33382 10.7105 4.36886 10.6353 4.43136L10.4899 4.55336C9.96576 4.99355 9.44331 5.43578 8.92259 5.88003C8.48525 6.25336 8.03792 6.64003 7.68059 6.95537C7.52586 7.09134 7.37274 7.22913 7.22125 7.3687C7.12237 7.45726 7.02887 7.55165 6.94125 7.65136C6.83786 7.77865 6.76108 7.92541 6.71547 8.08294C6.66987 8.24046 6.65636 8.40554 6.67576 8.56838C6.69516 8.73122 6.74707 8.88851 6.8284 9.03091C6.90974 9.17331 7.01885 9.29793 7.14925 9.39736C7.41484 9.60214 7.74976 9.69538 8.08296 9.65729C8.41615 9.6192 8.72139 9.45279 8.93392 9.19336C8.99259 9.12136 9.07059 8.99603 9.15059 8.86203C9.23592 8.7187 9.34059 8.53536 9.45659 8.33003C9.68792 7.9167 9.96859 7.40203 10.2399 6.90003C10.5622 6.30202 10.8819 5.70268 11.1993 5.10203L11.2866 4.93603C11.3315 4.85066 11.3447 4.75218 11.324 4.65799C11.3032 4.5638 11.2498 4.47999 11.1733 4.42136Z"
                          fill="#263238"
                        />
                        <path
                          d="M4.36192 3.65403C5.24953 2.90861 6.34521 2.4547 7.49992 2.35403V3.4987C7.49992 3.63131 7.5526 3.75848 7.64637 3.85225C7.74013 3.94602 7.86731 3.9987 7.99992 3.9987C8.13253 3.9987 8.2597 3.94602 8.35347 3.85225C8.44724 3.75848 8.49992 3.63131 8.49992 3.4987V2.35403C9.85338 2.47425 11.1186 3.07668 12.0651 4.05157C13.0116 5.02647 13.5764 6.30895 13.6566 7.66536H12.4999C12.3673 7.66536 12.2401 7.71804 12.1464 7.81181C12.0526 7.90558 11.9999 8.03276 11.9999 8.16536C11.9999 8.29797 12.0526 8.42515 12.1464 8.51892C12.2401 8.61269 12.3673 8.66536 12.4999 8.66536H13.6293C13.4559 10.2067 12.6806 11.4974 11.5173 12.444C11.4143 12.5278 11.349 12.6491 11.3354 12.7811C11.3219 12.9131 11.3614 13.0451 11.4453 13.148C11.5291 13.2509 11.6503 13.3163 11.7823 13.3298C11.9144 13.3433 12.0463 13.3038 12.1493 13.22C13.6333 12.0114 14.5959 10.2907 14.6626 8.23003C14.667 8.19555 14.6679 8.1607 14.6653 8.12603L14.6666 7.9987C14.6666 4.3167 11.6819 1.33203 7.99992 1.33203C4.31792 1.33203 1.33325 4.3167 1.33325 7.9987C1.33325 10.1667 2.34859 11.968 3.84659 13.216C3.94884 13.2972 4.07876 13.3351 4.20861 13.3217C4.33845 13.3083 4.45791 13.2447 4.54148 13.1444C4.62504 13.0442 4.66608 12.9152 4.65582 12.7851C4.64556 12.6549 4.58483 12.534 4.48659 12.448C3.34659 11.4974 2.55125 10.2034 2.37192 8.66536H3.49992C3.63253 8.66536 3.7597 8.61269 3.85347 8.51892C3.94724 8.42515 3.99992 8.29797 3.99992 8.16536C3.99992 8.03276 3.94724 7.90558 3.85347 7.81181C3.7597 7.71804 3.63253 7.66536 3.49992 7.66536H2.34259C2.41592 6.4107 2.89659 5.26536 3.65525 4.3607L4.47992 5.18536C4.5747 5.27368 4.70007 5.32177 4.8296 5.31948C4.95913 5.3172 5.08272 5.26472 5.17433 5.17311C5.26594 5.0815 5.31842 4.95791 5.3207 4.82838C5.32299 4.69885 5.27491 4.57348 5.18659 4.4787L4.36192 3.65403ZM11.1733 4.42136C11.0958 4.3617 11.0003 4.33018 10.9025 4.332C10.8047 4.33382 10.7105 4.36886 10.6353 4.43136L10.4899 4.55336C9.96576 4.99355 9.44331 5.43578 8.92259 5.88003C8.48525 6.25336 8.03792 6.64003 7.68059 6.95537C7.52586 7.09134 7.37274 7.22913 7.22125 7.3687C7.12237 7.45726 7.02887 7.55165 6.94125 7.65136C6.83786 7.77865 6.76108 7.92541 6.71547 8.08294C6.66987 8.24046 6.65636 8.40554 6.67576 8.56838C6.69516 8.73122 6.74707 8.88851 6.8284 9.03091C6.90974 9.17331 7.01885 9.29793 7.14925 9.39736C7.41484 9.60214 7.74976 9.69538 8.08296 9.65729C8.41615 9.6192 8.72139 9.45279 8.93392 9.19336C8.99259 9.12136 9.07059 8.99603 9.15059 8.86203C9.23592 8.7187 9.34059 8.53536 9.45659 8.33003C9.68792 7.9167 9.96859 7.40203 10.2399 6.90003C10.5622 6.30202 10.8819 5.70268 11.1993 5.10203L11.2866 4.93603C11.3315 4.85066 11.3447 4.75218 11.324 4.65799C11.3032 4.5638 11.2498 4.47999 11.1733 4.42136Z"
                          fill="#263238"
                        />
                      </svg>
                      <p>Speed</p>
                    </div>
                    <h4>
                      {liveMetrics?.scan_data?.vehicle_live_data?.speed}{" "}
                      <span>Km/h</span>
                    </h4>
                  </div>

                  <div className={styles.metrics_list}>
                    <div>
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.16675 0.5C8.85425 0.5 9.51571 0.588542 10.1511 0.765625C10.7865 0.942708 11.3855 1.19531 11.948 1.52344C12.5105 1.85156 13.0157 2.24219 13.4636 2.69531C13.9115 3.14844 14.3022 3.65625 14.6355 4.21875C14.9688 4.78125 15.2214 5.3776 15.3933 6.00781C15.5652 6.63802 15.6563 7.30208 15.6667 8C15.6667 8.6875 15.5782 9.34896 15.4011 9.98438C15.224 10.6198 14.9714 11.2188 14.6433 11.7812C14.3152 12.3438 13.9246 12.849 13.4714 13.2969C13.0183 13.7448 12.5105 14.1354 11.948 14.4688C11.3855 14.8021 10.7891 15.0547 10.1589 15.2266C9.52873 15.3984 8.86467 15.4896 8.16675 15.5C7.47925 15.5 6.81779 15.4115 6.18237 15.2344C5.54696 15.0573 4.948 14.8047 4.3855 14.4766C3.823 14.1484 3.31779 13.7578 2.86987 13.3047C2.42196 12.8516 2.03133 12.3438 1.698 11.7812C1.36466 11.2188 1.11206 10.6224 0.940186 9.99219C0.768311 9.36198 0.677165 8.69792 0.666748 8C0.666748 7.3125 0.75529 6.65104 0.932373 6.01562C1.10946 5.38021 1.36206 4.78125 1.69019 4.21875C2.01831 3.65625 2.40894 3.15104 2.86206 2.70312C3.31519 2.25521 3.823 1.86458 4.3855 1.53125C4.948 1.19792 5.54435 0.945312 6.17456 0.773438C6.80477 0.601562 7.46883 0.510417 8.16675 0.5ZM8.16675 14.5C8.76571 14.5 9.34123 14.4219 9.89331 14.2656C10.4454 14.1094 10.961 13.8906 11.4402 13.6094C11.9194 13.3281 12.3595 12.9896 12.7605 12.5938C13.1615 12.1979 13.5001 11.7604 13.7761 11.2812C14.0522 10.8021 14.2709 10.2839 14.4324 9.72656C14.5938 9.16927 14.672 8.59375 14.6667 8C14.6667 7.40104 14.5886 6.82552 14.4324 6.27344C14.2761 5.72135 14.0574 5.20573 13.7761 4.72656C13.4949 4.2474 13.1563 3.80729 12.7605 3.40625C12.3647 3.00521 11.9272 2.66667 11.448 2.39062C10.9688 2.11458 10.4506 1.89583 9.89331 1.73438C9.33602 1.57292 8.7605 1.49479 8.16675 1.5C7.56779 1.5 6.99227 1.57812 6.44019 1.73438C5.8881 1.89062 5.37248 2.10938 4.89331 2.39062C4.41414 2.67188 3.97404 3.01042 3.573 3.40625C3.17196 3.80208 2.83341 4.23958 2.55737 4.71875C2.28133 5.19792 2.06258 5.71615 1.90112 6.27344C1.73966 6.83073 1.66154 7.40625 1.66675 8C1.66675 8.59896 1.74487 9.17448 1.90112 9.72656C2.05737 10.2786 2.27612 10.7943 2.55737 11.2734C2.83862 11.7526 3.17716 12.1927 3.573 12.5938C3.96883 12.9948 4.40633 13.3333 4.8855 13.6094C5.36466 13.8854 5.88289 14.1042 6.44019 14.2656C6.99748 14.4271 7.573 14.5052 8.16675 14.5ZM9.5105 7.34375C9.61467 7.55208 9.66675 7.77083 9.66675 8C9.66675 8.20833 9.62769 8.40365 9.54956 8.58594C9.47144 8.76823 9.36467 8.92708 9.22925 9.0625C9.09383 9.19792 8.93498 9.30469 8.75269 9.38281C8.57039 9.46094 8.37508 9.5 8.16675 9.5C7.95841 9.5 7.7631 9.46094 7.58081 9.38281C7.39852 9.30469 7.23966 9.19792 7.10425 9.0625C6.96883 8.92708 6.86206 8.76823 6.78394 8.58594C6.70581 8.40365 6.66675 8.20833 6.66675 8C6.66675 7.79167 6.70581 7.59635 6.78394 7.41406C6.86206 7.23177 6.96883 7.07292 7.10425 6.9375C7.23966 6.80208 7.39852 6.69531 7.58081 6.61719C7.7631 6.53906 7.95841 6.5 8.16675 6.5C8.39591 6.5 8.61466 6.55208 8.823 6.65625L8.81519 6.64844L11.6902 3.77344L12.3933 4.47656L9.51831 7.35156L9.5105 7.34375ZM8.16675 8.5C8.30216 8.5 8.41935 8.45052 8.51831 8.35156C8.61727 8.2526 8.66675 8.13542 8.66675 8C8.66675 7.86458 8.61727 7.7474 8.51831 7.64844C8.41935 7.54948 8.30216 7.5 8.16675 7.5C8.03133 7.5 7.91414 7.54948 7.81519 7.64844C7.71623 7.7474 7.66675 7.86458 7.66675 8C7.66675 8.13542 7.71623 8.2526 7.81519 8.35156C7.91414 8.45052 8.03133 8.5 8.16675 8.5ZM13.1667 5.75C13.3282 6.10417 13.448 6.46875 13.5261 6.84375C13.6042 7.21875 13.6459 7.60417 13.6511 8C13.6511 8.72917 13.5157 9.42969 13.2449 10.1016C12.974 10.7734 12.5782 11.3698 12.0574 11.8906L11.3464 11.1797C11.7683 10.7578 12.0938 10.276 12.323 9.73438C12.5522 9.19271 12.6667 8.6224 12.6667 8.02344C12.6667 7.3776 12.5313 6.75521 12.2605 6.15625L13.1667 5.75ZM10.0105 3.90625C9.41154 3.63542 8.78914 3.5 8.14331 3.5C7.73185 3.5 7.33602 3.55208 6.95581 3.65625C6.5756 3.76042 6.21883 3.91406 5.8855 4.11719C5.55216 4.32031 5.25008 4.55469 4.97925 4.82031C4.70841 5.08594 4.47664 5.39062 4.28394 5.73438C4.09123 6.07812 3.94019 6.4349 3.83081 6.80469C3.72144 7.17448 3.66675 7.57292 3.66675 8C3.66675 8.59896 3.78133 9.17188 4.0105 9.71875C4.23966 10.2656 4.56519 10.7526 4.98706 11.1797L4.27612 11.8906C3.75529 11.3698 3.35685 10.776 3.08081 10.1094C2.80477 9.44271 2.66675 8.73958 2.66675 8C2.66675 7.49479 2.73185 7.00781 2.86206 6.53906C2.99227 6.07031 3.17716 5.63281 3.41675 5.22656C3.65633 4.82031 3.94279 4.45052 4.27612 4.11719C4.60946 3.78385 4.97925 3.5 5.3855 3.26562C5.79175 3.03125 6.22925 2.84635 6.698 2.71094C7.16675 2.57552 7.65633 2.51042 8.16675 2.51562C8.55737 2.51562 8.94019 2.55469 9.31519 2.63281C9.69019 2.71094 10.0574 2.83333 10.4167 3L10.0105 3.90625Z"
                          fill="#263238"
                        />
                      </svg>
                      <p>RPM</p>
                    </div>

                    <h4>
                      {liveMetrics?.scan_data?.vehicle_live_data?.engine_speed}{" "}
                      <span>rpm</span>
                    </h4>
                  </div>
                </div>

                <div className={styles.metrics_inner_wrapper}>
                  <div className={styles.metrics_list}>
                    <div>
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_8678_19896)">
                          <path
                            d="M7.99992 1.16797C7.7347 1.16797 7.48035 1.27333 7.29281 1.46086C7.10528 1.6484 6.99992 1.90275 6.99992 2.16797V10.168C6.57992 10.4813 6.33325 10.9746 6.33325 11.5013C6.33325 11.9433 6.50885 12.3673 6.82141 12.6798C7.13397 12.9924 7.55789 13.168 7.99992 13.168C8.44195 13.168 8.86587 12.9924 9.17843 12.6798C9.49099 12.3673 9.66659 11.9433 9.66659 11.5013C9.66659 10.9746 9.41992 10.5013 8.99992 10.168V9.16797H11.6666V7.83464H8.99992V6.5013H11.6666V5.16797H8.99992V3.83464H11.6666V2.5013H8.99992V2.16797C8.99992 1.90275 8.89456 1.6484 8.70703 1.46086C8.51949 1.27333 8.26514 1.16797 7.99992 1.16797ZM0.333252 10.5013V11.8346C0.779919 11.8346 0.859919 11.9746 1.19325 12.308C1.52659 12.6413 2.11325 13.168 2.99992 13.168C3.88659 13.168 4.47325 12.6413 4.80659 12.308C4.87992 12.228 4.93992 12.168 4.99992 12.108V10.608C4.47325 10.7813 4.09992 11.1213 3.85992 11.3613C3.52659 11.6946 3.44659 11.8346 2.99992 11.8346C2.55325 11.8346 2.47325 11.6946 2.13992 11.3613C1.80659 11.028 1.21992 10.5013 0.333252 10.5013ZM10.9999 10.5013V11.8346C11.4466 11.8346 11.5266 11.9746 11.8599 12.308C12.1933 12.6413 12.7799 13.168 13.6666 13.168C14.5533 13.168 15.1399 12.6413 15.4733 12.308C15.8066 11.9746 15.8866 11.8346 16.3333 11.8346V10.5013C15.4466 10.5013 14.8599 11.028 14.5266 11.3613C14.1933 11.6946 14.1133 11.8346 13.6666 11.8346C13.2199 11.8346 13.1399 11.6946 12.8066 11.3613C12.4733 11.028 11.8866 10.5013 10.9999 10.5013ZM5.66659 13.8346C4.77992 13.8346 4.19325 14.3613 3.85992 14.6946C3.52659 15.028 3.44659 15.168 2.99992 15.168C2.55325 15.168 2.47325 15.028 2.13992 14.6946C1.89992 14.4546 1.52659 14.1146 0.999919 13.9413V15.4413C1.05992 15.5013 1.11992 15.5613 1.19325 15.6413C1.52659 15.9746 2.11325 16.5013 2.99992 16.5013C3.88659 16.5013 4.47325 15.9746 4.80659 15.6413C5.13992 15.308 5.21992 15.168 5.66659 15.168C6.11325 15.168 6.19325 15.308 6.52659 15.6413C6.81992 15.928 7.29325 16.368 7.99992 16.4746C8.10659 16.5013 8.21992 16.5013 8.33325 16.5013C9.21992 16.5013 9.80659 15.9746 10.1399 15.6413C10.4733 15.308 10.5533 15.168 10.9999 15.168C11.4466 15.168 11.5266 15.308 11.8599 15.6413C12.1933 15.9746 12.7799 16.5013 13.6666 16.5013C14.5533 16.5013 15.1399 15.9746 15.4733 15.6413C15.5466 15.5613 15.6066 15.5013 15.6666 15.4413V13.9413C15.1399 14.1146 14.7666 14.4546 14.5266 14.6946C14.1933 15.028 14.1133 15.168 13.6666 15.168C13.2199 15.168 13.1399 15.028 12.8066 14.6946C12.4733 14.3613 11.8866 13.8346 10.9999 13.8346C10.1133 13.8346 9.52659 14.3613 9.19325 14.6946C8.85992 15.028 8.77992 15.168 8.33325 15.168C8.18659 15.168 8.08659 15.148 7.99992 15.1146C7.81325 15.048 7.69992 14.9213 7.47325 14.6946C7.13992 14.3613 6.55325 13.8346 5.66659 13.8346Z"
                            fill="#263238"
                          />
                          <path
                            d="M7.99992 1.16797C7.7347 1.16797 7.48035 1.27333 7.29281 1.46086C7.10528 1.6484 6.99992 1.90275 6.99992 2.16797V10.168C6.57992 10.4813 6.33325 10.9746 6.33325 11.5013C6.33325 11.9433 6.50885 12.3673 6.82141 12.6798C7.13397 12.9924 7.55789 13.168 7.99992 13.168C8.44195 13.168 8.86587 12.9924 9.17843 12.6798C9.49099 12.3673 9.66659 11.9433 9.66659 11.5013C9.66659 10.9746 9.41992 10.5013 8.99992 10.168V9.16797H11.6666V7.83464H8.99992V6.5013H11.6666V5.16797H8.99992V3.83464H11.6666V2.5013H8.99992V2.16797C8.99992 1.90275 8.89456 1.6484 8.70703 1.46086C8.51949 1.27333 8.26514 1.16797 7.99992 1.16797ZM0.333252 10.5013V11.8346C0.779919 11.8346 0.859919 11.9746 1.19325 12.308C1.52659 12.6413 2.11325 13.168 2.99992 13.168C3.88659 13.168 4.47325 12.6413 4.80659 12.308C4.87992 12.228 4.93992 12.168 4.99992 12.108V10.608C4.47325 10.7813 4.09992 11.1213 3.85992 11.3613C3.52659 11.6946 3.44659 11.8346 2.99992 11.8346C2.55325 11.8346 2.47325 11.6946 2.13992 11.3613C1.80659 11.028 1.21992 10.5013 0.333252 10.5013ZM10.9999 10.5013V11.8346C11.4466 11.8346 11.5266 11.9746 11.8599 12.308C12.1933 12.6413 12.7799 13.168 13.6666 13.168C14.5533 13.168 15.1399 12.6413 15.4733 12.308C15.8066 11.9746 15.8866 11.8346 16.3333 11.8346V10.5013C15.4466 10.5013 14.8599 11.028 14.5266 11.3613C14.1933 11.6946 14.1133 11.8346 13.6666 11.8346C13.2199 11.8346 13.1399 11.6946 12.8066 11.3613C12.4733 11.028 11.8866 10.5013 10.9999 10.5013ZM5.66659 13.8346C4.77992 13.8346 4.19325 14.3613 3.85992 14.6946C3.52659 15.028 3.44659 15.168 2.99992 15.168C2.55325 15.168 2.47325 15.028 2.13992 14.6946C1.89992 14.4546 1.52659 14.1146 0.999919 13.9413V15.4413C1.05992 15.5013 1.11992 15.5613 1.19325 15.6413C1.52659 15.9746 2.11325 16.5013 2.99992 16.5013C3.88659 16.5013 4.47325 15.9746 4.80659 15.6413C5.13992 15.308 5.21992 15.168 5.66659 15.168C6.11325 15.168 6.19325 15.308 6.52659 15.6413C6.81992 15.928 7.29325 16.368 7.99992 16.4746C8.10659 16.5013 8.21992 16.5013 8.33325 16.5013C9.21992 16.5013 9.80659 15.9746 10.1399 15.6413C10.4733 15.308 10.5533 15.168 10.9999 15.168C11.4466 15.168 11.5266 15.308 11.8599 15.6413C12.1933 15.9746 12.7799 16.5013 13.6666 16.5013C14.5533 16.5013 15.1399 15.9746 15.4733 15.6413C15.5466 15.5613 15.6066 15.5013 15.6666 15.4413V13.9413C15.1399 14.1146 14.7666 14.4546 14.5266 14.6946C14.1933 15.028 14.1133 15.168 13.6666 15.168C13.2199 15.168 13.1399 15.028 12.8066 14.6946C12.4733 14.3613 11.8866 13.8346 10.9999 13.8346C10.1133 13.8346 9.52659 14.3613 9.19325 14.6946C8.85992 15.028 8.77992 15.168 8.33325 15.168C8.18659 15.168 8.08659 15.148 7.99992 15.1146C7.81325 15.048 7.69992 14.9213 7.47325 14.6946C7.13992 14.3613 6.55325 13.8346 5.66659 13.8346Z"
                            fill="#263238"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_8678_19896">
                            <rect
                              width="16"
                              height="16"
                              fill="white"
                              transform="translate(0.333252 0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <p>Temp.</p>
                    </div>

                    <h4>
                      {
                        liveMetrics?.scan_data?.vehicle_live_data
                          ?.coolant_temperature
                      }
                    </h4>
                  </div>

                  <div className={styles.metrics_list}>
                    <div>
                      <svg
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_8678_19907)">
                          <path
                            d="M3 3C3 2.86739 3.05268 2.74021 3.14645 2.64645C3.24021 2.55268 3.36739 2.5 3.5 2.5H8.5C8.63261 2.5 8.75979 2.55268 8.85355 2.64645C8.94732 2.74021 9 2.86739 9 3V8C9 8.13261 8.94732 8.25979 8.85355 8.35355C8.75979 8.44732 8.63261 8.5 8.5 8.5H3.5C3.36739 8.5 3.24021 8.44732 3.14645 8.35355C3.05268 8.25979 3 8.13261 3 8V3Z"
                            fill="#263238"
                          />
                          <path
                            d="M1 2.5C1 1.96957 1.21071 1.46086 1.58579 1.08579C1.96086 0.710714 2.46957 0.5 3 0.5L9 0.5C9.53043 0.5 10.0391 0.710714 10.4142 1.08579C10.7893 1.46086 11 1.96957 11 2.5V10.5C11.5304 10.5 12.0391 10.7107 12.4142 11.0858C12.7893 11.4609 13 11.9696 13 12.5V13C13 13.1326 13.0527 13.2598 13.1464 13.3536C13.2402 13.4473 13.3674 13.5 13.5 13.5C13.6326 13.5 13.7598 13.4473 13.8536 13.3536C13.9473 13.2598 14 13.1326 14 13V8.5H13.5C13.3674 8.5 13.2402 8.44732 13.1464 8.35355C13.0527 8.25979 13 8.13261 13 8V4.875C13 4.74239 13.0527 4.61521 13.1464 4.52145C13.2402 4.42768 13.3674 4.375 13.5 4.375H14.995C14.984 3.899 14.942 3.481 14.794 3.153C14.7148 2.96228 14.5767 2.80183 14.4 2.695C14.216 2.585 13.936 2.5 13.5 2.5C13.3674 2.5 13.2402 2.44732 13.1464 2.35355C13.0527 2.25979 13 2.13261 13 2C13 1.86739 13.0527 1.74021 13.1464 1.64645C13.2402 1.55268 13.3674 1.5 13.5 1.5C14.064 1.5 14.534 1.61 14.912 1.836C15.295 2.064 15.546 2.387 15.706 2.743C16.001 3.398 16 4.208 16 4.824V7.999C16.0001 8.06474 15.9873 8.12987 15.9622 8.19065C15.9372 8.25143 15.9003 8.30666 15.8539 8.3532C15.8075 8.39974 15.7523 8.43665 15.6916 8.46184C15.6308 8.48703 15.5657 8.5 15.5 8.5H15V13C15 13.3978 14.842 13.7794 14.5607 14.0607C14.2794 14.342 13.8978 14.5 13.5 14.5C13.1022 14.5 12.7206 14.342 12.4393 14.0607C12.158 13.7794 12 13.3978 12 13V12.5C12 12.2348 11.8946 11.9804 11.7071 11.7929C11.5196 11.6054 11.2652 11.5 11 11.5V15.5H11.5C11.6326 15.5 11.7598 15.5527 11.8536 15.6464C11.9473 15.7402 12 15.8674 12 16C12 16.1326 11.9473 16.2598 11.8536 16.3536C11.7598 16.4473 11.6326 16.5 11.5 16.5H0.5C0.367392 16.5 0.240215 16.4473 0.146447 16.3536C0.0526784 16.2598 0 16.1326 0 16C0 15.8674 0.0526784 15.7402 0.146447 15.6464C0.240215 15.5527 0.367392 15.5 0.5 15.5H1V2.5ZM10 2.5C10 2.23478 9.89464 1.98043 9.70711 1.79289C9.51957 1.60536 9.26522 1.5 9 1.5H3C2.73478 1.5 2.48043 1.60536 2.29289 1.79289C2.10536 1.98043 2 2.23478 2 2.5V15.5H10V2.5Z"
                            fill="#263238"
                          />
                          <path
                            d="M3 3C3 2.86739 3.05268 2.74021 3.14645 2.64645C3.24021 2.55268 3.36739 2.5 3.5 2.5H8.5C8.63261 2.5 8.75979 2.55268 8.85355 2.64645C8.94732 2.74021 9 2.86739 9 3V8C9 8.13261 8.94732 8.25979 8.85355 8.35355C8.75979 8.44732 8.63261 8.5 8.5 8.5H3.5C3.36739 8.5 3.24021 8.44732 3.14645 8.35355C3.05268 8.25979 3 8.13261 3 8V3Z"
                            fill="#263238"
                          />
                          <path
                            d="M1 2.5C1 1.96957 1.21071 1.46086 1.58579 1.08579C1.96086 0.710714 2.46957 0.5 3 0.5L9 0.5C9.53043 0.5 10.0391 0.710714 10.4142 1.08579C10.7893 1.46086 11 1.96957 11 2.5V10.5C11.5304 10.5 12.0391 10.7107 12.4142 11.0858C12.7893 11.4609 13 11.9696 13 12.5V13C13 13.1326 13.0527 13.2598 13.1464 13.3536C13.2402 13.4473 13.3674 13.5 13.5 13.5C13.6326 13.5 13.7598 13.4473 13.8536 13.3536C13.9473 13.2598 14 13.1326 14 13V8.5H13.5C13.3674 8.5 13.2402 8.44732 13.1464 8.35355C13.0527 8.25979 13 8.13261 13 8V4.875C13 4.74239 13.0527 4.61521 13.1464 4.52145C13.2402 4.42768 13.3674 4.375 13.5 4.375H14.995C14.984 3.899 14.942 3.481 14.794 3.153C14.7148 2.96228 14.5767 2.80183 14.4 2.695C14.216 2.585 13.936 2.5 13.5 2.5C13.3674 2.5 13.2402 2.44732 13.1464 2.35355C13.0527 2.25979 13 2.13261 13 2C13 1.86739 13.0527 1.74021 13.1464 1.64645C13.2402 1.55268 13.3674 1.5 13.5 1.5C14.064 1.5 14.534 1.61 14.912 1.836C15.295 2.064 15.546 2.387 15.706 2.743C16.001 3.398 16 4.208 16 4.824V7.999C16.0001 8.06474 15.9873 8.12987 15.9622 8.19065C15.9372 8.25143 15.9003 8.30666 15.8539 8.3532C15.8075 8.39974 15.7523 8.43665 15.6916 8.46184C15.6308 8.48703 15.5657 8.5 15.5 8.5H15V13C15 13.3978 14.842 13.7794 14.5607 14.0607C14.2794 14.342 13.8978 14.5 13.5 14.5C13.1022 14.5 12.7206 14.342 12.4393 14.0607C12.158 13.7794 12 13.3978 12 13V12.5C12 12.2348 11.8946 11.9804 11.7071 11.7929C11.5196 11.6054 11.2652 11.5 11 11.5V15.5H11.5C11.6326 15.5 11.7598 15.5527 11.8536 15.6464C11.9473 15.7402 12 15.8674 12 16C12 16.1326 11.9473 16.2598 11.8536 16.3536C11.7598 16.4473 11.6326 16.5 11.5 16.5H0.5C0.367392 16.5 0.240215 16.4473 0.146447 16.3536C0.0526784 16.2598 0 16.1326 0 16C0 15.8674 0.0526784 15.7402 0.146447 15.6464C0.240215 15.5527 0.367392 15.5 0.5 15.5H1V2.5ZM10 2.5C10 2.23478 9.89464 1.98043 9.70711 1.79289C9.51957 1.60536 9.26522 1.5 9 1.5H3C2.73478 1.5 2.48043 1.60536 2.29289 1.79289C2.10536 1.98043 2 2.23478 2 2.5V15.5H10V2.5Z"
                            fill="#263238"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_8678_19907">
                            <rect
                              width="16"
                              height="16"
                              fill="white"
                              transform="translate(0 0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <p>Fuel</p>
                    </div>

                    <h4>
                      {
                        liveMetrics?.scan_data?.vehicle_live_data
                          ?.remaining_fuel
                      }{" "}
                      <span>%</span>
                    </h4>
                  </div>
                </div>
              </div>
              <div className={styles.address}>
                <div className={styles.timer}>
                  <p>Next update in:</p>
                  <p>{timer} seconds</p>
                </div>
                <div>
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1_2665)">
                      <path
                        d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12H4C4 16.418 7.582 20 12 20C16.418 20 20 16.418 20 12C20 7.582 16.418 4 12 4C9.536 4 7.332 5.114 5.865 6.865L8 9H2V3L4.447 5.446C6.28 3.336 8.984 2 12 2ZM13 7V11.585L16.243 14.828L14.828 16.243L11 12.413V7H13Z"
                        fill="#008069"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1_2665">
                        <rect width="22" height="22" fill="#008069" />
                      </clipPath>
                    </defs>
                  </svg>

                  <p>
                    {" "}
                    {liveMetrics?.created_at?.slice(0, 10)}{" "}
                    {liveMetrics?.created_at?.slice(11, 19)}
                  </p>
                </div>
                <div>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.75 9.75C18.75 7.95979 18.0388 6.2429 16.773 4.97703C15.5071 3.71116 13.7902 3 12 3C10.2098 3 8.4929 3.71116 7.22703 4.97703C5.96116 6.2429 5.25 7.95979 5.25 9.75C5.25 12.519 7.4655 16.128 12 20.451C16.5345 16.128 18.75 12.519 18.75 9.75ZM12 22.5C6.4995 17.5005 3.75 13.2495 3.75 9.75C3.75 7.56196 4.61919 5.46354 6.16637 3.91637C7.71354 2.36919 9.81196 1.5 12 1.5C14.188 1.5 16.2865 2.36919 17.8336 3.91637C19.3808 5.46354 20.25 7.56196 20.25 9.75C20.25 13.2495 17.5005 17.5005 12 22.5Z"
                      fill="#008069"
                    />
                    <path
                      d="M12 12C12.5967 12 13.169 11.7629 13.591 11.341C14.0129 10.919 14.25 10.3467 14.25 9.75C14.25 9.15326 14.0129 8.58097 13.591 8.15901C13.169 7.73705 12.5967 7.5 12 7.5C11.4033 7.5 10.831 7.73705 10.409 8.15901C9.98705 8.58097 9.75 9.15326 9.75 9.75C9.75 10.3467 9.98705 10.919 10.409 11.341C10.831 11.7629 11.4033 12 12 12ZM12 13.5C11.0054 13.5 10.0516 13.1049 9.34835 12.4017C8.64509 11.6984 8.25 10.7446 8.25 9.75C8.25 8.75544 8.64509 7.80161 9.34835 7.09835C10.0516 6.39509 11.0054 6 12 6C12.9946 6 13.9484 6.39509 14.6517 7.09835C15.3549 7.80161 15.75 8.75544 15.75 9.75C15.75 10.7446 15.3549 11.6984 14.6517 12.4017C13.9484 13.1049 12.9946 13.5 12 13.5Z"
                      fill="#008069"
                    />
                  </svg>
                  <p>{address}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* {!switchToSalesPage ? (
       
      ) : (
        <div className={styles.head}>
          <div className={styles.dongle_card_wrapper}>
            <div className={styles.dongle_card}>
              <div className={styles.dongle_img_wrapper}>
                <div className={styles.dongle_img_wrapper_inner}>
                  <img src={dongle1} alt="dongle_device" />
                </div>
              </div>
              <div className={styles.dongle_card_text}>
                <h1>Location and Health Tracker Device</h1>
                <p>Get started with smartcar dongle device installation</p>
              </div>
              <div className={styles.dongle_card_btn}>
                <div>
                  <a
                    rel="noreferrer"
                    href="https://flutterwave.com/store/motormata/xwipkivw0vm66n"
                    target="_blank"
                  >
                    Order
                  </a>
                </div>
              </div>

            
            </div>

            <div className={styles.dongle_card}>
              <div className={styles.dongle_img_wrapper}>
                <div className={styles.dongle_img_wrapper_inner}>
                  <img src={dongle2} alt="dongle_device" />
                </div>
              </div>
              <div className={styles.dongle_card_text}>
                <h1>Location Tracker Only</h1>
                <p>Get started with smartcar dongle device installation</p>
              </div>
              <div className={styles.dongle_card_btn}>
                <div>
                  <a
                    rel="noreferrer"
                    href="https://flutterwave.com/store/motormata/ykhj9qcb7jh59u"
                    target="_blank"
                  >
                    Order
                  </a>
                </div>
              </div>

          
            </div>
          </div>
        </div>
      )} */}
      <BottomNav />
    </section>
  );
}

export default Track;
